import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { PLAN_LABEL, fmtDate, openPortal, startTrial, errMsg } from "../../lib/billing";

export const PlanCard = () => {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const a = user?.access;
  if (!a) return null;
  const sub = a.subscription;
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const trial = () => run(async () => { await startTrial(); await refresh(); toast.success("已開始 Premium 免費試用！"); });
  const note = a.plan === "trial" ? `試用到 ${fmtDate(a.trial_ends_at)}，到期自動回到免費方案，不會扣款。`
    : a.source === "stripe" ? (sub?.cancel_at_period_end ? `已取消續訂，可使用到 ${fmtDate(new Date(sub.current_period_end * 1000).toISOString())}。` : `${sub?.interval === "year" ? "年繳" : "月繳"}，下次續訂日 ${fmtDate(new Date(sub.current_period_end * 1000).toISOString())}。`)
    : a.source === "grant" ? "由管理員開通的永久 Premium。" : a.source === "admin" ? "管理員帳號享有完整權限。" : "免費方案：每館可試幾課，注音練習館全部開放。";
  return (
    <div className="scroll-card p-5 flex flex-wrap items-center gap-4 font-serif-tc" data-testid="plan-card">
      <span className={`w-12 h-12 rounded-full flex items-center justify-center ${a.full ? "bg-amber-100" : "bg-stone-100"}`}>{a.full ? <Crown className="text-amber-500" /> : <Sparkles className="text-stone-500" />}</span>
      <div className="flex-1 min-w-[200px]">
        <div className="text-xs text-stone-500 font-en uppercase tracking-wider">目前方案</div>
        <div className="text-2xl font-black text-[var(--tea)]" data-testid="plan-card-name">{PLAN_LABEL[a.plan]}</div>
        <div className="text-sm text-stone-600" data-testid="plan-card-note">{note}</div>
      </div>
      <div className="flex flex-wrap gap-2">
        {a.plan === "starter" && !a.trial_used && <button data-testid="plan-card-trial-btn" disabled={busy} onClick={trial} className="h-11 px-5 rounded-full bg-[var(--jade)] text-white font-bold disabled:opacity-60">免費試用 Premium</button>}
        {(a.plan === "starter" || a.plan === "trial") && <button data-testid="plan-card-upgrade-btn" onClick={() => nav("/pricing")} className="h-11 px-5 rounded-full bg-[var(--vermilion)] text-white font-bold">升級 Premium</button>}
        {a.source === "stripe" && <button data-testid="plan-card-manage-btn" disabled={busy} onClick={() => run(openPortal)} className="h-11 px-5 rounded-full bg-white border-2 border-[var(--line)] font-bold disabled:opacity-60">管理訂閱</button>}
      </div>
    </div>
  );
};

export const UpgradeCard = ({ title = "這是 Premium 的完整報告" }) => {
  const nav = useNavigate();
  return (
    <div className="scroll-card p-10 text-center font-serif-tc" data-testid="upgrade-card">
      <Crown size={40} className="mx-auto text-amber-500" />
      <div className="text-2xl font-black text-[var(--tea)] mt-3">{title}</div>
      <p className="text-stone-600 mt-2">升級 Premium 或開始免費試用，就能看到每一館的詳細學習紀錄。</p>
      <button data-testid="upgrade-card-btn" onClick={() => nav("/pricing")} className="mt-5 h-11 px-6 rounded-full bg-[var(--vermilion)] text-white font-bold">查看方案</button>
    </div>
  );
};
